import { ThemeOptions } from '@material-ui/core';
// eslint-disable-next-line no-restricted-imports
import createPalette from '@material-ui/core/styles/createPalette';
import { AlmeTheme } from '../../models/AlmeTheme';
import { defaultTheme, defaultDarkTheme } from '../../models/AlmeTheme';

const { augmentColor } = createPalette({});

const primaryMain = '#0057BF';
const primaryContrast = defaultTheme.palette.getContrastText(primaryMain);
const primaryAugmented = augmentColor({ main: primaryMain });

const secondaryMain = '#09A761';
const secondaryContrast = defaultTheme.palette.getContrastText(secondaryMain);
const secondaryAugmented = augmentColor({ main: secondaryMain });

const overrides = {
    MuiAvatar: {
        colorDefault: {
            backgroundColor: '#343434',
        },
    },
    MuiFormLabel: {
        root: {
            color: 'rgba(0, 0, 0, 0.65)',
        },
    },
    MuiButton: {
        root: {
        },
        containedPrimary: {
            '&&': {
                color: `${primaryContrast}`,
            },
        },
        containedSecondary: {
            '&&': {
                color: `${secondaryContrast}`,
            },
        },
    },
};
const palette = {
    primary: {
        light: primaryAugmented.light,
        main: primaryMain,
        dark: primaryAugmented.dark,
    },
    secondary: {
        light: secondaryAugmented.light,
        main: secondaryMain,
        dark: secondaryAugmented.dark,
    },
    background: {
        paper: '#e5e9f0',
        default: '#F5F5F7',
    },
};


/* When overriding the fontFamily for a persona, uncomment this variable and the spread operators
* in the typography overrides.
*/
// const fontFamily = {
//     fontFamily: 'Montserrat',
//     letterSpacing: 'unset',
// };

const typography = {
    // This was added for the header (with the X and _ buttons) in iPhone 5
    // SE. It applies to other mobile devices in Portrait orientation. This
    // will affect other headings, so it may need to be moved in the future.
    h6: {
        [defaultTheme.breakpoints.down('xs')]: {
            fontSize: '16px',
        },
    },
    subtitle1: {
        ...defaultTheme.typography.subtitle1,
        //...fontFamily,
        fontWeight: 'bold',
    },
    subtitle2: {
        ...defaultTheme.typography.subtitle2,
        //...fontFamily,
    },
    caption: {
        ...defaultTheme.typography.caption,
        //...fontFamily,
    },
    body1: {
        ...defaultTheme.typography.body1,
        //...fontFamily,
    },
    body2: {
        ...defaultTheme.typography.body2,
        //...fontFamily,
    },
    button: {
        ...defaultTheme.typography.button,
        textTransform: 'none',
    },
    //ontFamily: 'Montserrat',
};

const lightModeTheme = { palette, overrides, typography } as ThemeOptions;

const primaryMainDark = '#85CBFF';
const primaryContrastDark = defaultDarkTheme.palette.getContrastText(primaryMainDark);
const secondaryMainDark = '#00CE7C';
const secondaryContrastDark = defaultDarkTheme.palette.getContrastText(secondaryMainDark);

const darkPalette = {
    type: 'dark',
    primary: {
        light: '#007AFF',
        main: primaryMainDark,
        dark: '#E1F4FF',
    },
    secondary: {
        light: '#09A761',
        main: secondaryMainDark,
        dark: '#82EB96',
    },
};

const darkTypography = {
    // This was added for the header (with the X and _ buttons) in iPhone 5
    // SE. It applies to other mobile devices in Portrait orientation. This
    // will affect other headings, so it may need to be moved in the future.
    h6: {
        [defaultDarkTheme.breakpoints.down('xs')]: {
            fontSize: '16px',
        },
    },
    button: {
        textTransform: 'none',
    },
};

const darkOverrides = {
    MuiButton: {
        containedPrimary: {
            '&&': {
                color: `${primaryContrastDark}`,
            },
        },
        containedSecondary: {
            '&&': {
                color: `${secondaryContrastDark}`,
            },
        },
    },
};

const darkModeTheme = { palette: darkPalette, overrides: darkOverrides, typography: darkTypography } as ThemeOptions;

const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: darkModeTheme,
} as AlmeTheme;

export default appThemeMain;